import $ from 'jquery';

function init() {
  openForgot()
  closeForgot()
  logoutClearSess()
  inputs()
}

function openForgot() {
  $('.login-forgotLink').on('click', function(e) {
    e.preventDefault()

    $('.login-login, .login-header').slideUp(250)
    $('.login-forgot').slideDown(250)
  })
}

function closeForgot() {
  $('.login-back').on('click', function(e) {
    e.preventDefault()

    $('.login-forgot').slideUp(250)
    $('.login-login, .login-header').slideDown(250)
  })
}

function logoutClearSess() {
  $('.account-logout').on('click', function(e) {
    e.preventDefault()

    $(this).addClass('button--saving')
    sessionStorage.clear()
    cart.clearCart()
    window.location.href = "/account/logout"
  })
}

function inputs() {
  const $input = $('.input-wrapper input')
  $input.blur(function() {
    const $wrapper = $(this).closest('.input-wrapper')
    if ($(this).val() !== '') {
      $wrapper.addClass('input-wrapper--filled')
    }
  })
}

$(function () {
  init()
})
